/**
 * Sidebar Configuration
 */

// Icon registry - centralized icon management
export const SIDEBAR_ICONS = {
  gold: require('@/assets/side_bar_icons/gold.svg'),
  layout: require('@/assets/side_bar_icons/layout.svg'),
  list: require('@/assets/side_bar_icons/list.svg'),
  report: require('@/assets/side_bar_icons/report.svg'),
  users: require('@/assets/side_bar_icons/users.svg'),
  verified: require('@/assets/side_bar_icons/verified.svg'),
  logout: require('@/assets/side_bar_icons/logout.svg'),
  dashboard: require('@/assets/side_bar_icons/dashboard.svg'),
  services: require('@/assets/side_bar_icons/services.svg'),
  applications: require('@/assets/side_bar_icons/code.svg'),
  customers: require('@/assets/side_bar_icons/customers.svg'),
  notification: require('@/assets/side_bar_icons/notification.svg'),
  datahub: require('@/assets/side_bar_icons/data_hub.svg'),
  workflow: 'fa-code-fork' // Font Awesome icon
};

/**
 * Base configuration for SystemAdmin role
 */
export const SYSTEM_ADMIN_CONFIG = {
  sections: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      items: [
        {
          id: 'admin_dashboard',
          label: 'Dashboard',
          icon: 'dashboard',
          route: '/system_admin/admin_dashboard',
          routeName: 'admin_dashboard'
        }
      ]
    },
    {
      id: 'management',
      title: 'Management',
      items: [
        {
          id: 'applications',
          label: 'Applications',
          icon: 'applications',
          route: '/system_admin/client_applications',
          routeName: 'client_applications'
        },
        {
          id: 'workflows',
          label: 'Workflows',
          icon: 'workflow',
          route: '/system_admin/view_workflow_status',
          routeName: 'view_workflow_status'
        },
        {
          id: 'assets',
          label: 'Assets',
          icon: 'gold',
          route: '/system_admin/view_assets',
          routeName: 'view_assets'
        },
        {
          id: 'users',
          label: 'Users',
          icon: 'users',
          route: '/system_admin/users',
          routeName: 'users'
        },
        {
          id: 'instant_verify_requests',
          label: 'Instant Verify Requests',
          icon: 'verified',
          route: '/system_admin/service_applications',
          routeName: 'service_applications'
        },
        {
          id: 'services',
          label: 'Services',
          icon: 'services',
          route: '/system_admin/service_mangement',
          routeName: 'service_mangement'
        }
      ]
    },
    {
      id: 'system',
      title: 'System',
      items: [
        {
          id: 'communications',
          label: 'Communications',
          icon: 'notification',
          route: { name: 'system_communications' },
          routeName: 'system_communications',
          badge: 'unreadComms'
        }
      ]
    },
    {
      id: 'services_section',
      title: 'Services',
      items: [
        {
          id: 'data_hub',
          label: 'Data Hub',
          icon: 'datahub',
          route: { name: 'client_admins' },
          routeName: 'client_admins'
        }
      ]
    }
  ]
};

/**
 * Base configuration for ClientAdmin/Client role - Project Dashboard
 */
export const CLIENT_PROJECT_DASHBOARD_CONFIG = {
  conditions: {
    showProjectDashboardTabs: true,
    hasProjectId: true
  },
  sections: [
    {
      id: 'project_overview',
      title: null, // No section title
      items: [
        {
          id: 'project_dashboard',
          label: 'Dashboard',
          icon: 'dashboard',
          route: { name: 'project_dashboard' },
          routeName: 'project_dashboard'
        },
        {
          id: 'service_dashboard',
          label: 'Services',
          icon: 'services',
          route: { name: 'service_dashboard' },
          routeName: 'service_dashboard'
        }
      ]
    }
  ]
};

/**
 * Base configuration for ClientAdmin/Client role - Project Management
 */
export const CLIENT_PROJECT_MANAGEMENT_CONFIG = {
  conditions: {
    showProjectTabs: true
  },
  sections: [
    {
      id: 'management',
      title: 'Management',
      items: [
        {
          id: 'questions',
          label: 'Questions',
          icon: 'list',
          route: { name: 'question_management' },
          routeName: 'question_management'
        },
        {
          id: 'forms',
          label: 'Forms',
          icon: 'report',
          route: { name: 'form_management' },
          routeName: 'form_management'
        },
        {
          id: 'templates',
          label: 'Templates',
          icon: 'layout',
          route: { name: 'template_management' },
          routeName: 'template_management'
        },
        {
          id: 'users_dropdown',
          label: 'Users',
          icon: 'users',
          type: 'dropdown',
          roleRestriction: ['ClientAdmin'],
          children: [
            {
              id: 'client_admins',
              label: 'Client Admins',
              route: { name: 'client_admin' },
              routeName: 'client_admin'
            },
            {
              id: 'customers',
              label: 'Customers',
              route: { name: 'view_customers' },
              routeName: 'view_customers'
            }
          ]
        },
        {
          id: 'assets',
          label: 'Assets',
          icon: 'gold',
          route: { name: 'create_asset' },
          routeName: 'create_asset'
        }
      ]
    },
    {
      id: 'system',
      title: 'System',
      items: [
        {
          id: 'communications',
          label: 'Communications',
          icon: 'notification',
          route: { name: 'system_communications' },
          routeName: 'system_communications',
          badge: 'unreadComms'
        }
      ]
    },
    {
      id: 'services_section',
      title: 'Services',
      items: [
        {
          id: 'data_hub',
          label: 'Data Hub',
          icon: 'datahub',
          route: { name: 'data_hub' },
          routeName: 'data_hub'
        },
        {
          id: 'instant_verify',
          label: 'Instant Verify',
          icon: 'verified',
          route: { name: 'instant_verify' },
          routeName: 'instant_verify',
          conditions: {
            routeNames: ['project_table', 'project_dashboard', 'system_communications']
          }
        },
        {
          id: 'service_extracts',
          label: 'Service Extracts',
          icon: 'report',
          route: { name: 'service_extracts' },
          routeName: 'service_extracts',
          featureFlag: 'service_extract'
        }
      ]
    }
  ]
};

/**
 * Base configuration for ClientAdmin/Client role - Instant Verify
 */
export const CLIENT_INSTANT_VERIFY_CONFIG = {
  conditions: {
    showInstantVerifyTabs: true
  },
  sections: [
    {
      id: 'instant_verify_section',
      title: null,
      items: [
        {
          id: 'your_services',
          label: 'Your Services',
          icon: 'verified',
          route: { name: 'services' },
          routeName: 'services'
        },
        {
          id: 'instant_services',
          label: 'Services',
          icon: 'services',
          route: { name: 'instant_services' },
          routeName: 'instant_services',
        }
      ]
    }
  ]
};

/**
 * Route groups for determining which config to show
 */
export const ROUTE_GROUPS = {
  projectTabs: [
    'service_dashboard', 'edit_workflow', 'behalf_application', 'batch_processing', 'workflow_router', 
    'client_view_workflow', 'admin_view_workflow', 'workflow_services', 'service_rules', 'client_services', 
    'arrange_workflow', 'reasons_for_usage', 'upload_consent', 'confirm_workflow', 
    'workflow_dashboard', 'view_customers', 'view_service', 'create_asset', 
    'view_asset', 'project_dashboard', 'project_table', 'view_customer',
    'question_management', 'conditional_questions', 'form_management', 
    'template_management', 'manage_form', 'client_admin', 'customer_data', 
    'template_configuration', 'view_client', 'view_client_admin', 
    'customer_applications', 'system_communications', 'view_assets',
    'data_hub', 'data_hub_individuals', 'data_hub_individual_profile', 'register_question_selection','thank_you_builder', 'thank_you_configuration', 'workflow_templates',
    'view_batches', 'service_extracts'
  ],
  projectDashboardTabs: [
    'project_dashboard', 'service_dashboard', 'edit_workflow', 'behalf_application',
    'batch_processing', 'workflow_router', 'client_view_workflow', 'admin_view_workflow', 'workflow_services', 'service_rules',
    'client_services', 'arrange_workflow', 'reasons_for_usage', 'upload_consent',
    'confirm_workflow', 'workflow_dashboard', 'view_customers', 'view_customer',
    'view_service', 'create_asset', 'view_asset', 'template_management',
    'question_management', 'conditional_questions', 'form_management',
    'client_admin', 'customer_data', 'template_configuration', 'view_client',
    'view_client_admin', 'system_communications', 'view_assets', 'data_hub',
    'data_hub_individuals', 'data_hub_individual_profile', 'register_question_selection','thank_you_builder', 'thank_you_configuration', 'workflow_templates',
    'view_batches', 'service_extracts'

  ],
  instantVerifyTabs: [
    'instant_services', 'services', 'verify_logs', 'utilize_service', 'instant_verify'
  ]
};

/**
 * Client-specific overrides
 * 
 * Usage:
 * CLIENT_OVERRIDES['client_name'] = {
 *   'SystemAdmin': { ... override config ... },
 *   'ClientAdmin': { ... override config ... }
 * }
 */
export const CLIENT_OVERRIDES = {
  // Verify domain Client user custom sidebar
  'suzuki': {
    'Client': {
      sections: [
        {
          id: 'suzuki_main',
          title: null,
          items: [
            {
              id: 'workbench',
              label: 'Workbench',
              icon: 'gold',
              route: { name: 'workbench' },
              routeName: 'workbench',
              badge: 'unreadWorkbench'
            },
            {
              id: 'toolbox',
              label: 'Toolbox',
              icon: 'verified',
              route: { name: 'toolbox' },
              routeName: 'toolbox'
            },
            {
              id: 'data_hub',
              label: 'My Clients',
              icon: 'datahub',
              route: { name: 'data_hub' },
              routeName: 'data_hub'
            }
          ]
        }
      ]
    }
  },
  'swift': {
    'Client': {
      sections: [
        {
          id: 'swift_main',
          title: null,
          items: [
            {
              id: 'workbench',
              label: 'Workbench',
              icon: 'gold',
              route: { name: 'workbench' },
              routeName: 'workbench',
              badge: 'unreadWorkbench'
            },
            {
              id: 'toolbox',
              label: 'Toolbox',
              icon: 'verified',
              route: { name: 'toolbox' },
              routeName: 'toolbox'
            },
            {
              id: 'data_hub',
              label: 'My Clients',
              icon: 'datahub',
              route: { name: 'data_hub' },
              routeName: 'data_hub'
            }
          ]
        }
      ]
    }
  },
  'mobiafrica': {
    'Client': {
      sections: [
        {
          id: 'mobi_main',
          title: null,
          items: [
            {
              id: 'workbench',
              label: 'Workbench',
              icon: 'gold',
              route: { name: 'workbench' },
              routeName: 'workbench',
              badge: 'unreadWorkbench'
            },
            {
              id: 'toolbox',
              label: 'Toolbox',
              icon: 'verified',
              route: { name: 'toolbox' },
              routeName: 'toolbox'
            },
            {
              id: 'data_hub',
              label: 'My Clients',
              icon: 'datahub',
              route: { name: 'data_hub' },
              routeName: 'data_hub'
            }
          ]
        }
      ]
    }
  }
};

/**
 * Helper function to get sidebar configuration
 * 
 * @param {String} userRole - User role (SystemAdmin, ClientAdmin, Client)
 * @param {String} clientName - Client name from domain detection
 * @param {Object} context - Additional context (route, project_id, etc.)
 * @returns {Object} Sidebar configuration
 */
export function getSidebarConfig(userRole, clientName = null, context = {}) {
  // Check for client-specific override first
  if (clientName && CLIENT_OVERRIDES[clientName] && CLIENT_OVERRIDES[clientName][userRole]) {
    return CLIENT_OVERRIDES[clientName][userRole];
  }

  // Return default configuration based on role and context
  if (userRole === 'SystemAdmin') {
    return SYSTEM_ADMIN_CONFIG;
  }

  if (userRole === 'ClientAdmin' || userRole === 'Client') {
    // Determine which client config to show based on current route
    const currentRoute = context.routeName;

    const configs = [];

    // Check if we should show project dashboard tabs
    if (ROUTE_GROUPS.projectDashboardTabs.includes(currentRoute) && context.projectId) {
      configs.push(CLIENT_PROJECT_DASHBOARD_CONFIG);
    }

    // Check if we should show project management tabs
    if (ROUTE_GROUPS.projectTabs.includes(currentRoute)) {
      configs.push(CLIENT_PROJECT_MANAGEMENT_CONFIG);
    }

    // Check if we should show instant verify tabs
    if (ROUTE_GROUPS.instantVerifyTabs.includes(currentRoute)) {
      configs.push(CLIENT_INSTANT_VERIFY_CONFIG);
    }

    // Merge configs if multiple apply
    if (configs.length > 0) {
      return mergeConfigs(configs);
    }
  }

  return { sections: [] };
}

/**
 * Merge multiple configurations
 */
function mergeConfigs(configs) {
  const merged = { sections: [] };
  configs.forEach(config => {
    if (config.sections) {
      merged.sections = [...merged.sections, ...config.sections];
    }
  });
  return merged;
}

/**
 * Filter menu items based on role and conditions
 */
export function filterMenuItems(items, userRole, context) {
  return items.filter(item => {
    // Check role restrictions
    if (item.roleRestriction && !item.roleRestriction.includes(userRole)) {
      return false;
    }

    // Check feature flag conditions
    if (item.featureFlag) {
      const activeFlags = context.activeFeatureFlags || [];
      if (!activeFlags.includes(item.featureFlag)) {
        return false;
      }
    }

    // Check route-specific conditions
    if (item.conditions && item.conditions.routeNames) {
      if (!item.conditions.routeNames.includes(context.routeName)) {
        return false;
      }
    }

    return true;
  });
}
